import { useCallback } from 'react';

import { ITournamentLocationsRepository } from 'domain/repositories/ITournamentLocationsRepository';
import { httpClient } from 'infrastructure/providers/common/httpClient';

import { TournamentRoutes } from './routes';

export const useTournamentLocationsRepository: ITournamentLocationsRepository = () => {
  const fetchTournamentLocations: ReturnType<ITournamentLocationsRepository>['fetchTournamentLocations'] =
    useCallback(
      () =>
        httpClient.get(TournamentRoutes.getTournamentLocations()).then((response) => response.data),
      [],
    );

  return {
    fetchTournamentLocations,
  };
};
